export default "__VITE_ASSET__BLoUBR2a__"